import React, { useState } from 'react';
import { RegionName } from '../../../types/region.mjs';
import BurgerButton from '../../Basic/BurgerButton/BurgerButton.mjs';
import { SearchIcon } from '../../Basic/Icons/ButtonIcons/ButtonIcons.mjs';
import Logo from '../../Basic/Icons/Logo/Logo.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import CurrentWeather from '../CurrentWeather/CurrentWeather.mjs';
import { StyledNavigation, StyledFlexContainer, StyledTopNavigationLogoAnchor, StyledSearch, StyledHorizontalList, StyledSearchIconButton, StyledButton, StyledMobileSearchContainer, StyledMobileSearch } from './TopNavigation.styles.mjs';
import { useTheme } from 'styled-components';

const TopNavigation = ({ isOpen, weatherProps, horizontalListProps, searchProps, buttonProps, burgerButtonProps, homeUrl, region }) => {
    const theme = useTheme();
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const handleSearchIconClick = () => {
        setIsSearchOpen(!isSearchOpen);
    };
    const handleBurgerButtonClick = () => {
        burgerButtonProps.onClick();
    };
    const handleSearchClose = () => {
        setIsSearchOpen(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledNavigation, null,
            React.createElement(StyledFlexContainer, { alignItems: "center", justifyContent: "space-between", padding: { default: '18px 16px 12px', lg: '12px 60px' }, gap: { default: '0', md: '3.75rem' }, maxWidth: `${theme.breakpoints.max}`, margin: '0 auto' },
                React.createElement(FlexContainer, { justifyContent: "space-between" },
                    React.createElement(BurgerButton, { isOpen: isOpen, onClick: handleBurgerButtonClick }),
                    React.createElement(StyledTopNavigationLogoAnchor, { href: homeUrl },
                        React.createElement(Logo, { region: region.selectedRegion.name || RegionName.DEFAULT }))),
                isOpen || isSearchOpen ? (React.createElement(StyledSearch, Object.assign({}, searchProps, { onClose: handleSearchClose, testId: "search" }))) : (React.createElement(StyledHorizontalList, Object.assign({ testId: "top-navigation-menu" }, horizontalListProps))),
                React.createElement(FlexContainer, { justifyContent: "space-between" },
                    !isOpen && !isSearchOpen && (React.createElement(StyledSearchIconButton, { onClick: handleSearchIconClick, "aria-label": "Open search" },
                        React.createElement(SearchIcon, { color: theme.colors.searchBarIconColor }))),
                    !isOpen && !isSearchOpen && React.createElement(CurrentWeather, Object.assign({}, weatherProps)),
                    React.createElement(StyledButton, Object.assign({ uppercased: buttonProps.uppercased, backgroundColor: buttonProps.backgroundColor, hoverColor: buttonProps.hoverColor, borderColor: buttonProps.borderColor, isSymmetricalPadding: buttonProps.isSymmetricalPadding }, buttonProps))))),
        isSearchOpen && (React.createElement(StyledMobileSearchContainer, null,
            React.createElement(StyledMobileSearch, Object.assign({}, searchProps, { onClose: handleSearchClose, testId: "mobile-search" }))))));
};

export { TopNavigation as default };
//# sourceMappingURL=TopNavigation.mjs.map
